import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';

import useService from '../../../useService';

import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../formConfig';
import { dehydrateFormData } from '../../../utils/formDataParser';
import { IWebsiteUpdateV2 } from '../../../apkUpdateInfoModel';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestCreateWebsiteUpdateInfoV2, getDashBoardNamesOptions, getLudoVersionNumberOptions, getTestBucketsNamesOptions } =
		useService();

	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.WEBSITE_NAME].setRenderProps({ options: [{ label: 'zupee.com', id: 'zupee.com' }] });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.DASHBOARD_NAME].setRenderProps({ getOptions: getDashBoardNamesOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.VERSION].setRenderProps({ getOptions: getLudoVersionNumberOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.BUCKET_NAME].setRenderProps({ getOptions: getTestBucketsNamesOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.CONTROL_BUCKET_NAME].setRenderProps({ options: [{ label: 'control', id: 'control' }] });

	const cloneWebsiteUpdateInfo = async (clonedData: IWebsiteUpdateV2) => {
		setShowLoader(true);
		try {
			await requestCreateWebsiteUpdateInfoV2(clonedData);
			showAlert('Website Update Info cloned');
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(true);
		}
	};

	const handleFormSubmit = (submittedData: any) => {
		cloneWebsiteUpdateInfo(dehydrateFormData(submittedData));
	};
	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: _get(location, ['state', 'rowData']),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
